import type { ReactNode } from 'react';

export interface FooterLinksProps {
  children: ReactNode;
  'aria-label': string;
}

export function FooterLinks({ children, ...rest }: FooterLinksProps) {
  return (
    <nav aria-label={rest['aria-label']} className="flex w-full flex-wrap items-center justify-center gap-x-6 gap-y-2">
      {children}
    </nav>
  );
}
